const JIVO_SRC = '//code.jivo.ru/widget/lkPnpjaKSR';
const OPEN_TIMEOUT = 20000;

let openRequested = false;
let destroyed = false;
let injected = false;
let isOpen = false;
let pendingOpens = [];

function hideWidget() {
  if (!destroyed && typeof jivo_destroy === 'function') {
    jivo_destroy();
    destroyed = true;
  }
}

window.jivo_onLoadCallback = function () {
  destroyed = false;
  if (openRequested) {
    openRequested = false;
    if (typeof jivo_api !== 'undefined') {
      jivo_api.open();
    }
  }
};

window.jivo_onOpen = function () {
  isOpen = true;
  const resolvers = pendingOpens;
  pendingOpens = [];
  resolvers.forEach((fn) => fn());
};

window.jivo_onClose = function () {
  isOpen = false;
  hideWidget();
};

export function openJivoChat() {
  return new Promise((resolve) => {
    if (isOpen) {
      resolve();
      return;
    }

    let settled = false;
    const finish = () => {
      if (!settled) {
        settled = true;
        resolve();
      }
    };
    pendingOpens.push(finish);
    setTimeout(finish, OPEN_TIMEOUT);

    if (injected && !destroyed && typeof jivo_api !== 'undefined') {
      jivo_api.open();
      return;
    }

    openRequested = true;

    if (!injected) {
      injected = true;
      const s = document.createElement('script');
      s.src = JIVO_SRC;
      s.async = true;
      document.body.appendChild(s);
    } else if (typeof jivo_init === 'function') {
      jivo_init();
    }
  });
}

export function initJivoButton(buttonId = 'jivoChatButton') {
  const button = document.getElementById(buttonId);
  if (!button) return;

  button.addEventListener('click', () => {
    if (button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.disabled = true;

    openJivoChat().finally(() => {
      button.classList.remove('is-loading');
      button.disabled = false;
    });
  });
}

window.openJivoChat = openJivoChat;
